import { Injectable } from '@angular/core';
import { NewMessageBoardMessage } from './new-message-board';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { EditedMessageBoardMessage } from './edited-message-board';

@Injectable()
export class MessageBoardService {

  constructor(public httpClient: HttpClient) { }

  saveNewMessage(message: NewMessageBoardMessage) {
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/MessageBoard`;
    return this.httpClient.post(url, message)
  }

  saveEditedMessage(message: EditedMessageBoardMessage) {
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/MessageBoard/EditMessage`;
    const params = {
      id: message.id,
      messageLocation: message.messageLocation,
      message: message.message,
      startDate: message.startDate,
      endDate: message.endDate,
      priority: message.priority, 
    }
    return this.httpClient.patch<any[]>(url, params);
  }

  getMessagesBetweenDates(startDate: string, endDate: string, location: string): any {
    const httpOptions = {};
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/MessageBoard/GetMessagesBetweenDates?startDate=${startDate}&endDate=${endDate}&location=${location}`;   
    return this.httpClient.get(url, httpOptions);
  }

  getTodaysMessagesForPage(location: string): any{
    const httpOptions = {};
    const url = `${environment.dotNetApiUrl}/${Area.factoring}/MessageBoard/GetTodaysMessagesForPage?location=${location}`;   
    return this.httpClient.get(url, httpOptions);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/message-board/message-board.service.ts